/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RestartPersonaInquiry_restartPersonaInquiry_PersonaInquiry_person_SignedCreditApplicationPerson = { readonly __typename: 'SignedCreditApplicationPerson', readonly firstName: string, readonly lastName: string };

export type RestartPersonaInquiry_restartPersonaInquiry_PersonaInquiry = { readonly __typename: 'PersonaInquiry', readonly status: _Types.PersonaInquiryStatus, readonly inquiryId: string, readonly person: RestartPersonaInquiry_restartPersonaInquiry_PersonaInquiry_person_SignedCreditApplicationPerson };

export type RestartPersonaInquiry_Mutation = { readonly __typename: 'Mutation', readonly restartPersonaInquiry: RestartPersonaInquiry_restartPersonaInquiry_PersonaInquiry };


export type RestartPersonaInquiryVariables = _Types.Exact<{
  inquiryId: _Types.Scalars['String']['input'];
}>;


export type RestartPersonaInquiry = RestartPersonaInquiry_Mutation;


export const RestartPersonaInquiryDocument = gql`
    mutation RestartPersonaInquiry($inquiryId: String!) {
  restartPersonaInquiry(inquiryId: $inquiryId) {
    status
    inquiryId
    person {
      firstName
      lastName
    }
  }
}
    `;
export type RestartPersonaInquiryMutationFn = Apollo.MutationFunction<RestartPersonaInquiry, RestartPersonaInquiryVariables>;

/**
 * __useRestartPersonaInquiry__
 *
 * To run a mutation, you first call `useRestartPersonaInquiry` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartPersonaInquiry` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartPersonaInquiry, { data, loading, error }] = useRestartPersonaInquiry({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *   },
 * });
 */
export function useRestartPersonaInquiry(baseOptions?: Apollo.MutationHookOptions<RestartPersonaInquiry, RestartPersonaInquiryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartPersonaInquiry, RestartPersonaInquiryVariables>(RestartPersonaInquiryDocument, options);
      }
export type RestartPersonaInquiryHookResult = ReturnType<typeof useRestartPersonaInquiry>;
export type RestartPersonaInquiryMutationResult = Apollo.MutationResult<RestartPersonaInquiry>;
export type RestartPersonaInquiryMutationOptions = Apollo.BaseMutationOptions<RestartPersonaInquiry, RestartPersonaInquiryVariables>;